import { useMemo, type FC } from "react";

import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import PriorityHighOutlinedIcon from "@mui/icons-material/PriorityHighOutlined";
import { Alert, Button, type AlertColor } from "@mui/material";
import clsx from "clsx";
import { useAlert } from "../../contexts/AlertProvider";

import "./GeneralAlert.scss";

export const GeneralAlert: FC<{ isGeneral?: boolean; }> = ({ isGeneral }) => {
  const {
    alertText,
    position,
    severity,
    hideGeneralAlert,
    alertAction,
    alertActionLabel,
  } = useAlert();

  const icon = useMemo(() => {
    return severity === "warning" ? (
      <PriorityHighOutlinedIcon
        style={{ color: "#ebc262", fontSize: "1.8rem" }}
      />
    ) : severity === "error" ? (
      <CloseOutlinedIcon style={{ color: "#ec5454", fontSize: "1.8rem" }} />
    ) : (
      <CheckOutlinedIcon style={{ color: "#6dda6d", fontSize: "1.8rem" }} />
    );
  }, [severity]);

  if (isGeneral && hideGeneralAlert) return <></>;

  return (
    <div
      className={clsx(
        "alert-container",
        position || "",
        severity || "",
      )}
    >
      {alertText && (
        <Alert
          icon={<div className="icon-container">{icon}</div>}
          severity={(severity as AlertColor) || "warning"}
          action={
            alertAction && alertActionLabel ? (
              <Button
                color="inherit"
                size="small"
                onClick={() => alertAction()}
              >
                {alertActionLabel}
              </Button>
            ) : undefined
          }
        >
          {alertText}
        </Alert>
      )}
    </div>
  );
};
